import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, map, Observable, of, switchMap } from 'rxjs';
import { DateUtil } from '../lib/date-util';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { StringUtil } from '../lib/string-util';
import { DataService } from './data.service';
import { IDataServiceEntityFileEntryList, IDataServiceEntity } from './data.service.interface';
import { NumberUtil } from '../lib/number-util';

@Injectable({
    providedIn: 'root'
})
export class ImageService {

    /**
     * @param dataService
     */
    constructor(private dataService: DataService, private authService: AuthService) { }

    /**
     * 
     * @param code 
     */
    loadOne(code: string): Observable<string> {
        return this.dataService.loadFile('images', code).pipe(
            map(encodedFile => encodedFile)
        );
    }

    /**
     * 
     * @param code 
     * @param encodedImage 
     * @returns 
     */
    save(code: string, encodedImage: string): Observable<string> {
        return this.dataService.saveFile('images', code, encodedImage);
    }

}
